var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWenzi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1L2 1L2 3.33333L6.80003 3.33333L6.80002 14.9999L9.20002 14.9999L9.20003 3.33333L14 3.33333L14 1Z",
    fill: "#626262"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 5,
    height: 1,
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1L4 1L4 3.33333L8.40007 3.33333L8.40007 14.9999L10.6001 14.9999L10.6001 3.33333L15 3.33333L15 1Z",
    fill: "#60D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWenzi);
export default __webpack_public_path__ + "static/media/wenzi .9202aed33d6f1e7a856388782447cf8b.svg";
export { ForwardRef as ReactComponent };